// extracted by css-extract-rspack-plugin
export default {"content":"AgentVerificationDocumentComparisonModal_content__55R51","documentPreview":"AgentVerificationDocumentComparisonModal_documentPreview__olDIq"};